import React, { useEffect, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { isEmpty } from 'lodash';
import Logo from 'components/Logo';
import poweredBy from 'assets/images/powered_by_pharmaforce.svg';
import user from 'assets/icon/user-icon.svg';
import useOidc from 'hooks/useOidc';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip';

import notification from "assets/icon/notification-icon.svg";

const Header = () => {
  const { logout } = useOidc();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [hidePoweredBy, setHidePoweredBy] = useState(false);
  const navigate = useNavigate();
  const userName = sessionStorage.getItem('pharmaforce')
  const profileObject = JSON.parse(userName);
  //console.log(profileObject.profile,"userName")

  console.log(profileObject && profileObject.profile.username[0])
  useEffect(() => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const interval = setInterval(() => { }, 1000);

    const theme = sessionStorage.getItem('theme') || "PF";

    if (theme === "PF") setHidePoweredBy(true);

    if (!access_token) {
      navigate('/');
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  const fetchData = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const { sub } = profile || {};
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/users/User/getUserDetails`,
        {
          params: { Id: sub },
          headers: {
            'Content-type': 'application/json',
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchData();
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
  };

  return (
    <>
      <Navbar color='white' light className='py-1 app-header'>
        <div className='d-flex align-items-center'>
          <NavbarBrand href='/' className='me-0'>
            <Logo height={50} />
          </NavbarBrand>
          <h6 className='ps-3 ms-3 d-inline mx-1 mt-1 mb-0 claimsConnect_hed'>
            Case Management
          </h6>
        </div>
        <div className='ms-auto powered-by'>
          <img src={poweredBy} title='' alt='' hidden={hidePoweredBy} />
        </div>

        {loading && (
          <Nav className='ps-4 nav_info'>

            {/* <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav caret className='font-weight-500' style={{ fontSize: "14px", }}>
                <span className=''><img style={{ background: "#702C621A", padding: "7px", borderRadius: "50px", marginRight: "8px", }} src={user} alt="" /></span>
                {profileObject ? profileObject.profile.username : ''}
              </DropdownToggle>
              <DropdownMenu className='shadow'>
                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}



            {/* <UncontrolledDropdown nav className="profile-dropdown">
              <DropdownToggle
                nav
                className=""
                style={{ position: "relative" }}
              >
                <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>Notification Center</Tooltip>
                  )}
                  placement="bottom"
                >
                  <img src={notification} alt="" />
                </OverlayTrigger>
                <span id="spnNotificationCnt" className="notifcnt"></span>
              </DropdownToggle>
            </UncontrolledDropdown> */}

            <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav className='font-weight-500'>
                <OverlayTrigger
                  overlay={(props) => (
                    <Tooltip {...props}>
                      View Profile
                    </Tooltip>
                  )}
                  placement="bottom"
                >
                  <img src={user} alt="" />
                </OverlayTrigger>
              </DropdownToggle>
              <DropdownMenu className="shadow">
                <DropdownItem >
                  <div id="app">
                    <div className="text-end">
                      <div className="text-start">
                        <div className="">
                          <div id="circle-avatar" className="text-center mx-auto my-2 h3">
                            {profileObject.profile.username[0]}
                          </div>

                          <h5 className="text-center" style={{ whiteSpace: "normal", color: "#702c62", }}>
                            {profileObject.profile.username}
                          </h5>
                            <ul>
                              <li className='my-3'><a style={{fontSize:"12px",textDecoration:"none",color:"#000000",}} href="https://apps.thepharmaforce.com/" target='_blank'>Apps Dashboard</a></li>
                            </ul>

                          {/* <div className="list-group list-group-flush">
                            <button className="list-group-item list-group-item-action">
                              <small>Apps Dashboard</small>
                            </button>
                          </div> */}

                          <div className="d-grid log_info">
                            <button className="btn btn-secondary" onClick={handleLogout} >
                              <small>Logout</small>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>


          </Nav>
        )}
      </Navbar>
    </>
  );
};

export default Header;
